/* eslint-disable no-underscore-dangle */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { useKeyNavigation } from "@silvertours/front-entities";
import { Theme } from "@silvertours/front-shared";
import { DisplayExpressionWrapper, IconAirport, IconCity, IconRail, NoResultsItem, NoResultsItemWrapper, ResultItem, ResultsListWrapper } from "./LocationSuggest.styles";
var LocationSuggest = function(param) {
    var results = param.results, connectedInputContainer = param.connectedInputContainer, onItemClick = param.onItemClick, onLastElementBlur = param.onLastElementBlur, noResultsText = param.noResultsText, loading = param.loading;
    var getNoResultsItem = function getNoResultsItem() {
        return loading ? null : /*#__PURE__*/ _jsx(NoResultsItemWrapper, {
            children: /*#__PURE__*/ _jsx(NoResultsItem, {
                children: noResultsText
            })
        });
    };
    var listRef = useRef(null);
    var isMobileTouchDevice = Theme.useIsMobileTouchDevice();
    var handleEnter = function(item) {
        onItemClick(item);
    };
    var ref = useKeyNavigation(results || [], listRef, handleEnter), focusedItem = ref.focusedItem, onMouseEnter = ref.onMouseEnter, onMouseLeave = ref.onMouseLeave;
    useEffect(function() {
        if (isMobileTouchDevice && (connectedInputContainer === null || connectedInputContainer === void 0 ? void 0 : connectedInputContainer.current)) {
            connectedInputContainer.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        isMobileTouchDevice,
        connectedInputContainer
    ]);
    var getDisplayIconAndDescription = function(suggestion, suggest) {
        var icon = null;
        var html = "";
        switch(suggestion.type){
            case "city":
            case "citywithoutrail":
                icon = /*#__PURE__*/ _jsx(IconCity, {});
                break;
            case "multiairports":
            case "multiairport_single":
            case "airport":
                icon = /*#__PURE__*/ _jsx(IconAirport, {});
                break;
            case "multirail_single":
            case "multirail":
            case "rail_only":
            case "rail":
                icon = /*#__PURE__*/ _jsx(IconRail, {});
                break;
            case "normal":
            case "all":
            default:
                break;
        }
        if (!suggest) {
            icon = null;
        }
        html = suggestion.title;
        return {
            icon: icon,
            html: html
        };
    };
    var getDisplayExpression = function(suggestion) {
        var suggest = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var displayExpression = getDisplayIconAndDescription(suggestion, suggest);
        if (typeof displayExpression.html === "string" && suggest) {
            displayExpression.html = // eslint-disable-next-line react/no-danger
            /*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: displayExpression.html
                }
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(DisplayExpressionWrapper, {
                    children: displayExpression.icon
                }),
                displayExpression.html
            ]
        });
    };
    return results && results.length ? /*#__PURE__*/ _jsx(ResultsListWrapper, {
        ref: listRef,
        children: results.map(function(suggestion, index) {
            return /*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(ResultItem, {
                    type: "button",
                    tabIndex: 0,
                    onBlur: onLastElementBlur,
                    onMouseDown: function() {
                        return onItemClick(suggestion);
                    },
                    onMouseEnter: function() {
                        return onMouseEnter(index);
                    },
                    onMouseLeave: onMouseLeave,
                    selected: index === focusedItem,
                    children: getDisplayExpression(suggestion)
                })
            }, suggestion.cityName + index);
        })
    }) : getNoResultsItem();
};
export { LocationSuggest };
